var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1pt",
    height: "1pt",
    viewBox: "0 0 1 1",
    x: -1,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1",
    transform: "translate(0,-0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0.8125 0.5 C 0.8125 0.671875 0.671875 0.8125 0.5 0.8125 C 0.328125 0.8125 0.1875 0.671875 0.1875 0.5 C 0.1875 0.328125 0.328125 0.1875 0.5 0.1875 C 0.671875 0.1875 0.8125 0.328125 0.8125 0.5 Z M 0.8125 0.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(80.392157%,23.921569%,31.372549%)",
      fillOpacity: 1
    },
    d: "M 0.5 0.1875 C 0.328125 0.1875 0.1875 0.328125 0.1875 0.5 C 0.1875 0.671875 0.328125 0.8125 0.5 0.8125 C 0.671875 0.8125 0.8125 0.671875 0.8125 0.5 C 0.8125 0.417969 0.78125 0.335938 0.722656 0.277344 C 0.664062 0.21875 0.582031 0.1875 0.5 0.1875 Z M 0.65625 0.613281 L 0.613281 0.65625 L 0.5 0.542969 L 0.386719 0.65625 L 0.34375 0.613281 L 0.457031 0.5 L 0.34375 0.386719 L 0.386719 0.34375 L 0.5 0.457031 L 0.613281 0.34375 L 0.65625 0.386719 L 0.542969 0.5 Z M 0.65625 0.613281 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/red-cross.0d8414c4.svg";
export { ForwardRef as ReactComponent };